import _extends from "@babel/runtime/helpers/esm/extends";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";

var _class, _class2, _temp;

import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { globalObject } from '@skbkontur/global-object';
import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { RenderContainer } from "../../../internal/RenderContainer";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { isTestEnv } from "../../../lib/currentEnvironment";
import { rootNode } from "../../../lib/rootNode";
import { styles } from "../Toast.styles";
import { ToastView } from "../ToastView";
import { ToastStatic } from "../ToastStatic";
export var ToastDataTids = {
  toastStatic: 'StaticToast',
  toastView: 'ToastView__root',
  action: 'ToastView__action',
  close: 'ToastView__close'
};
/**
 * Показывает уведомления.
 *
 * Доступен статический метод: `Toast.push(notification, action?, showTime?)`.
 * Однако, при его использовании не работает кастомизация, они не поддерживаются в `React@18`, а также могут быть проблемы с перекрытием уведомления другими элементами страницы.
 *
 * Для статических тостов <u>рекомендуется</u> использовать компонент [SingleToast](https://tech.skbkontur.ru/react-ui/#/Components/SingleToast) - в нём исправлены эти проблемы.
 *
 */

export var Toast = rootNode(_class = (_temp = _class2 = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Toast, _React$Component);

  Toast.push = function push(notification, action, showTime) {
    ToastStatic.push(notification, action, showTime);
  };

  Toast.close = function close() {
    ToastStatic.close();
  };

  function Toast(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.rootRef = /*#__PURE__*/React.createRef();

    _this.close = function () {
      safelyCall(_this.props.onClose, _this.state.notification, _this.state.action);

      _this.setState({
        notification: null,
        action: null
      });
    };

    _this.setRootRef = function (element) {
      _this.setRootNode(element); // @ts-expect-error: See: https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31065.


      _this.rootRef.current = element;
    };

    _this._clearTimer = function () {
      if (_this._timeout) {
        globalObject.clearTimeout(_this._timeout);
        _this._timeout = null;
      }
    };

    _this._setTimer = function () {
      var _this$state$showTime;

      _this._clearTimer();

      var showTime = _this.state.action ? 7000 : 3000;
      showTime = (_this$state$showTime = _this.state.showTime) != null ? _this$state$showTime : showTime;
      _this._timeout = globalObject.setTimeout(_this.close, showTime);
    };

    _this._refToast = function (element) {
      _this._toast = element;
    };

    _this.state = {
      notification: null,
      action: null,
      id: 0,
      showTime: null
    };
    return _this;
  }

  var _proto = Toast.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._clearTimer();
  };

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(ThemeContext.Consumer, null, function (theme) {
      _this2.theme = _this2.props.theme ? ThemeFactory.create(_this2.props.theme, theme) : theme;
      return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
        value: _this2.theme
      }, /*#__PURE__*/React.createElement(RenderContainer, null, /*#__PURE__*/React.createElement(TransitionGroup, null, _this2._renderToast())));
    });
  }
  /**
  * Показывает тост с `notification` в качестве сообщения.
  * Тост автоматически скрывается через 3 или 7 секунд,
  * в зависимости от наличия у него кнопки `action`.
  * Время показа можно задать вручную, передав `showTime`.
  *
  * @public
  * @param {string} notification
  * @param {Action} action `action` опциональный параметр формата `{ label: string, handler: function }`
  * добавляет кнопку в виде ссылки при клике на которую вызывается переданный handler
  * @param {number} showTime Время существования Toast в миллисекундах
  */
  ;

  _proto.push = function push(notification, action, showTime) {
    if (this.state.notification) {
      this.close();
    }

    safelyCall(this.props.onPush, notification, action);
    this.setState(function (_ref) {
      var id = _ref.id;
      return {
        notification: notification,
        action: action,
        id: id + 1,
        showTime: showTime
      };
    }, this._setTimer);
  }
  /**
  * @public
  */
  ;

  _proto._renderToast = function _renderToast() {
    var _this$state = this.state,
        notification = _this$state.notification,
        action = _this$state.action,
        id = _this$state.id;

    if (!notification) {
      return null;
    }

    var toastProps = {
      onMouseEnter: this._clearTimer,
      onMouseLeave: this._setTimer,
      onClose: this.close,
      children: notification,
      'aria-label': this.props['aria-label'],
      action: action
    };
    return /*#__PURE__*/React.createElement(CSSTransition, {
      key: id,
      classNames: {
        enter: styles.enter(),
        enterActive: styles.enterActive(),
        exit: styles.exit(),
        exitActive: styles.exitActive()
      },
      timeout: {
        enter: 200,
        exit: 150
      },
      enter: !isTestEnv,
      exit: !isTestEnv,
      nodeRef: this.rootRef
    }, /*#__PURE__*/React.createElement(CommonWrapper, _extends({
      rootNodeRef: this.setRootRef
    }, this.props), /*#__PURE__*/React.createElement(ToastView, _extends({
      ref: this._refToast
    }, toastProps))));
  };

  return Toast;
}(React.Component), _class2.__KONTUR_REACT_UI__ = 'Toast', _class2.displayName = 'Toast', _temp)) || _class;

function safelyCall(fn) {
  if (fn) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    fn.apply(void 0, args);
  }
}